import {BaseModel} from "./BaseModel";
import {InvoiceItem} from "./InvoiceItem";

export enum FinanceType {
	Invoice = "Faktura",
	Payment = "Uplata"
}

export class CustomerFinances extends BaseModel {

	constructor () {
		super()
	}

	id: string
	type: FinanceType
	description: string
	customerId: string
	vat: number
	price: number | string
	invoiceNumber: string
	invoiceDeliveryDate: string
	invoiceIssueDate: string
	invoiceDueDate: string
	invoiceContractId: string
	invoiceItems: InvoiceItem[]
	paymentDate: string
	paymentInvoiceId: string
	date: string
}
